module.exports = __webpack_public_path__ + "static/img/program_Rss_img.daef7079.png";